export default __webpack_public_path__ + "9d2f8661cc372a764c7bc979dfa39963.svg";